export const ticketTypeEnum = {
    SINGLE: 1,
    COMBO: 2,
    SYSTEM: 3,
};

export const acceptOddChangeEnum = {
    NO: 3,
    YES: 1,
    HIGHER: 2,
};

export const producerTypeEnum = {
    PRE_MATCH: 1,
    LIVE: 2,
};

export const TICKET_STATUSES = {
    unknown: 0,
    open: 1,
    closed: 2,
    cancelled: 3,
    won: 4,
    lost: 5,
    draw: 6,
    void: 7,
    halfLost: 8,
    halfWon: 9,
    refunded: 10,
    paid: 12,
    cashOut: 13,
};

export const TICKET_PRINT_MODES = {
    ticketId: 1,
    ticketCode: 2,
    requestId: 3,
};

export const TICKET_SOURCES = {
    all: 0,
    cashier: 1,
    terminal: 2,
};

export const VOUCHER_STATUSES = {
    all: 0,
    active: 1,
    inactive: 2,
    cancelled: 3,
};

export const TERMINAL_STATUSES = {
    active: 1,
    inactive: 2,
};

export const EVENT_TYPE_ENUM = {
    regular: 1,
    outright: 2,
};
